import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, List, ListItem, ListItemButton, ListItemIcon, ListItemText, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';
import { NombrePila } from './NombrePila';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ErrorDialog from '../utilities/ErrorDialog';

export interface INombrePilaNewProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
}

export interface INombrePilaNewState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    errors: any[];
    openErroDialog: boolean;
}

export default class NombrePilaNew extends React.Component<INombrePilaNewProps, INombrePilaNewState> {
    _nombrePila: NombrePila = new NombrePila();
    
    public constructor(props: INombrePilaNewProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            errors: [],
            openErroDialog: false
        }
    }

    componentWillReceiveProps(nextProps: Readonly<INombrePilaNewProps>, nextContext: any): void {
        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open && this.state.errors.length == 0} fullWidth>
                    <DialogTitle>
                        Nuevo nombre de pila
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.hasErrors && (
                                <Alert severity="error" style={{marginBottom: '10px'}}>
                                    {
                                        this.state.errorMessage
                                    }
                                </Alert>
                            )
                        }
                        <Box>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' label='Nombre' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._nombrePila.nombre = event.target.value;
                                    }
                                }}></TextField>
                            </FormControl>
                            <FormControl fullWidth variant="standard">
                                <InputLabel id="labelComunidadAutonoma">Seleccione el sexo</InputLabel>
                                <Select label="Seleccione el sexo" labelId='labelComunidadAutonoma' onChange={(event: SelectChangeEvent) => {
                                    this._nombrePila.sexo = event.target.value;
                                }}>
                                    <MenuItem value={'M'}>Femenino</MenuItem>
                                    <MenuItem value={'H'}>Masculino</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Save.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.errors.length > 0} fullWidth>
                    <DialogTitle>
                        Error
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant='body2'>
                            Se ha producido el siguiente error al guardar los datos:
                        </Typography>
                        <div className='errors'>
                            <List>
                                {
                                    this.state.errors.map((value: string, index: number) => {
                                        return (
                                            <ListItem disablePadding>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <CancelOutlinedIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary={value} />
                                                </ListItemButton>
                                            </ListItem>
                                        )
                                    })
                                }
                            </List>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {
                            this.setState(
                                {
                                    errors: []
                                }
                            );
                        }}>Ok</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                openErroDialog: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Save() {
        if(this._nombrePila.nombre == '' || this._nombrePila.nombre == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/nombrespila`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._nombrePila),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._nombrePila = new NombrePila();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false,
                    openErroDialog: true
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._nombrePila = new NombrePila();
        });
    }
}